import { Record } from 'immutable';
import { find, isEmpty, filter, includes, concat, map, forEach } from 'lodash';
import { DEFAULT_KEY_ORDER } from 'commons-vehicle/constants/dataConversions.js';

const QuoteItemCategoryRecord = Record({
    enabled: false,
    visible: true,
    selected: false,
    declined: false,
    singlePackageSelection: true,
    id: 0,
    order: DEFAULT_KEY_ORDER,
    description: '',
    note: '',
    dataType: 0,
    imageUrl: '',
    webUrl: '',
    itemsPackages: [],
    items: [],
});

function getSelectedItems(items) {
    return filter(items, (item) => {
        return item.selected;
    });
}

class QuoteItemCategory extends QuoteItemCategoryRecord {
    getItemsPackageContent(itemsPackageSelectionCode) {
        if (isEmpty(itemsPackageSelectionCode)) {
            return [];
        }

        const selectedItemsPackage = find(this.itemsPackages, (itemsPackage) => {
            return itemsPackage.selectionCode === itemsPackageSelectionCode;
        });
        if (!selectedItemsPackage || isEmpty(selectedItemsPackage.includedCodes)) {
            return [];
        }

        return filter(this.items, (item) => {
            return includes(selectedItemsPackage.includedCodes, item.selectionCode);
        });
    }

    getSelectedItemsCount() {
        return getSelectedItems(this.items).length;
    }

    getSelectedItemsPackagesCount() {
        return getSelectedItems(this.itemsPackages).length;
    }

    getSelectedItemsAndPackages() {
        return concat(getSelectedItems(this.itemsPackages), getSelectedItems(this.items));
    }

    getSelectedItemsPackagesAmountsWithContent(isLease, taxesFactor, selectedFinanceTerm) {
        const selectedPackages = getSelectedItems(this.itemsPackages);

        const selectedPackagesWithContent = map(selectedPackages, (itemsPackage) => {
            const items = this.getItemsPackageContent(itemsPackage.selectionCode);

            let { retail, taxes, payment, paymentTaxes } = itemsPackage.calculateItemAmounts(
                isLease,
                selectedFinanceTerm,
                taxesFactor
            );

            forEach(items, (item) => {
                const itemAmounts = item.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor, itemsPackage);
                retail += itemAmounts.retail;
                taxes += itemAmounts.taxes;
                payment += itemAmounts.payment;
                paymentTaxes += itemAmounts.paymentTaxes;
            });

            return {
                itemsPackage,
                items,
                retail,
                taxes,
                payment,
                paymentTaxes,
            };
        });

        return selectedPackagesWithContent;
    }
}

export default QuoteItemCategory;
